(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/oddset-kambi/components/common/assets/javascripts/constants.js') >= 0) return;  svs.modules.push('/modules/oddset-kambi/components/common/assets/javascripts/constants.js');
"use strict";


const MenuTabTypes = {
  Play: 'spela',
  MyBets: 'mina-spel',
  GameGuide: 'spelguide',
  Widget: 'widgetyta'
};
const widgetAreaPrefix = 'oddsetWidgetArea';
const KambiWidgetEvents = {
  SET_BETRADAR_ID: 'setBetradarId'
};
const OddsmindConstants = {
  MOBILE_NAVMENU_HEIGHT: 72,
  BETSLIP_HEIGHT: 48,
  MOBILE_HEADER_HEIGHT: 74,
  MOBILE_HEADER_HEIGHT_SIGNED_IN: 118,
  DESKTOP_BETSLIP_OFFSET: 30,
  LI_BAR: 31,
  BETSLIP_VISIBLE: 'VISIBLE',
  BETSLIP_HIDDEN: 'HIDDEN'
};
setGlobal('svs.oddset_kambi.components.common.constants', {
  MenuTabTypes,
  widgetAreaPrefix,
  KambiWidgetEvents,
  OddsmindConstants
});

 })(window);